module.exports = __webpack_public_path__ + "img/ykt_framework_Image .8aa6cc87.png";